import React, { useState } from 'react';
import { FilterIcon, ReturnIcon, SearchIcon } from '../../../svg';

const Search = ({ value, onChange, onSubmit, filtersOpen, onToggleFilters }) => {
    const [focused,setFocused] = useState(false);
    return (
        <div className='h-[49px] py-1.5'>
            <div className="px-[10px]">
                <div className='flex items-center gap-x-2'>
                    <div className="w-full flex dark:bg-dark_bg_2 rounded-lg ps-2">
                        { focused || value ?
                           ( <span className='w-8 flex items-center justify-center rotateAnimation cursor-pointer'
                           onClick={() => onChange("")}>
                                <ReturnIcon className="fill-green_1 w-5"/>
                            </span>
                            ) : (

                                <span className='w-8 flex items-center justify-center'>
                                    <SearchIcon className="dark:fill-dark_svg_2 w-5"/>
                                </span>
                            )
                        }
                        <input type="text"
                            placeholder='البحث أو بدء محادثة جديدة'
                            className="input"
                            value={value}
                            onChange={(e) => onChange(e.target.value)}
                            onFocus={()=> setFocused(true)}
                            onBlur={()=> !value && setFocused(false)}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    onSubmit?.();
                                }
                            }}
                        />

                    </div>
                    <button className={`btn ${filtersOpen ? "bg-dark_hover_1" : ""}`} onClick={onToggleFilters} title="الفلاتر">
                        <FilterIcon className="dark:fill-dark_svg_2"/>
                    </button>
                </div>
            </div>
        </div>
    );
}

export default Search;
